import Coming from "./components/soon/Coming";

function App() {
  return (
    <div className="w-full min-h-screen bg-bodyColor text-lightText">
      <Coming />
    </div>
  );
}

export default App;
